<template>
  <div>
    <world-nav/>
    <b-form-group id="name" label="カード名">
      <b-form-input v-model="info.name" />
    </b-form-group>
    <b-form-group id="memo" label="説明">
      <remark-editor v-model="info.memo"
        :danger="1000" :warn="800" />
      <b-button @click="buildCardText">効果テキストを追加</b-button>
    </b-form-group>
    <b-form-group id="image" label="カード画像">
      <b-form-input v-model="info.icon" debounce="500"></b-form-input>
      <b-img :src="info.icon | coalesceImage" width="80px" height="100px" fluid />
    </b-form-group>
    <b-form-group id="num" label="使用回数"
      description="入手時に使用できる回数">
      <b-form-input v-model="init.num" 
        type="number" min="1" max="99" number />
    </b-form-group>
    <b-form-group id="num" label="最大回数"
      description="合成等で回復できる最大回数">
      <b-form-input v-model="init.max" 
        type="number" min="1" max="99" number />
    </b-form-group>
    <b-form-group id="prepare" label="準備動作"
      description="行動する前に実行されるイベント">
      <div class="event-ctrl-bar">
        <b-button v-b-toggle.edit-prepare>編集</b-button>
        <digest class="digest" v-model="prepare" />
      </div>
      <b-collapse id="edit-prepare" accordion="card-event">
        <command-editor v-model="prepare"
          :command="prepareCommand" class="prepare" />
      </b-collapse>
    </b-form-group>
    <b-form-group id="mix" label="合成動作"
      description="合成する時に実行されるイベント">
      <template v-if="mix != null">
        <b-checkbox-group v-model="mix.hook" 
          :options="[
            { value:'card/mix.add-num', text:'合成するカードの残回数を加算する' }
          ]" />
      </template>
      <template v-else>
        <b-button @click="card.push({'@method':'mix',code:[],hook:[]})">イベント追加</b-button>        
      </template>
    </b-form-group>
    <b-card v-if="$store.state.Session.admin" 
      id="dice-battle" title="ダイスバトル専用動作"
      sub-title="ルール「ダイスバトル」で発生するイベント">
      <template v-if="enableDiceBattle">
        <b-tabs>
          <b-tab title="初期化動作">
            <command-editor v-model="initBattle" :info="value"
              :command="initBattleCommand" class="prepare" />
          </b-tab>
          <b-tab title="選択動作">
            <command-editor v-model="ai" :info="value"
              :command="aiCommand" class="prepare" />
          </b-tab>
          <b-tab title="入力動作">
            <command-editor v-model="input" :info="value"
              :command="inputCommand" class="prepare" />
          </b-tab>
          <b-tab title="詠唱開始動作">
            <command-editor v-model="startAction" :info="value"
              :command="startActionCommand"
              class="prepare">
              <b-form-group id="aria" label="詠唱時間">
                <b-form-select v-model="startAction.args.Aria" 
                  :options="[
                    { value:100, text:'100：自己対象行動' },
                    { value:200, text:'200：味方対象行動' },
                    { value:500, text:'500：速攻・射撃' },
                    { value:750, text:'750：魔法' },
                    { value:1000, text:'1000：通常攻撃' },
                    { value:1250, text:'1250：近接行動' },
                    { value:1500, text:'1500：溜行動' },
                    { value:2000, text:'2000：大魔法' },
                    { value:3000, text:'3000：特大魔法' },
                    { value:4000, text:'4000：超魔法' }
                  ]" number />
              </b-form-group>
              <b-form-group id="armor" label="耐久値">
                <b-form-select v-model="startAction.args.Armor" 
                  :options="[
                    { value:1000, text:'1000' },
                    { value:1500, text:'1500：無抵抗行動' },
                    { value:2000, text:'2000：後衛行動' },
                    { value:2250, text:'2250' },
                    { value:2500, text:'2500：前衛行動' },
                    { value:2750, text:'2750' },
                    { value:3000, text:'3000：準SA' },
                    { value:3500, text:'3500：SA' },
                    { value:4000, text:'4000：防御' },
                    { value:4500, text:'4500：無敵' }
                  ]" number />
              </b-form-group>
            </command-editor>
          </b-tab>
          <b-tab title="行動動作">
            <command-editor v-model="action" :info="value"
              :command="actionCommand" class="prepare" />
          </b-tab>
        </b-tabs>
      </template>
      <template v-else>
        <b-button @click="enableDiceBattle = true">イベント追加</b-button>        
      </template>
    </b-card>
    
    <div class="ctrl-bar">
      <b-button type="button" @click="$router.back()">戻る</b-button>
      <b-button variant="danger" @click="remove">
        <font-awesome-icon icon="times" class="icon fa-1x" />
        このカードを削除
      </b-button>
    </div>
  </div>
</template>

<script>
import { phina } from '@/canvas'
import WorldNav from '@/components/WorldNav'
// import ResponseMessage from '@/components/ResponseMessage'
// import CodeEditor from '@/components/CodeEditor'
import RemarkEditor from '@/components/RemarkEditor'
import { default as CommandEditor, Digest } from '@/components/CommandEditor'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
import CardTextBuilder from './CardTextBuilder'
export default {
  filters: {
    coalesceImage (image) {
      return image || './img/card/front.png'
    }
  },
  components: {
    WorldNav,
    RemarkEditor,
    CommandEditor,
    Digest
    // ResponseMessage,
    // CodeEditor
  },
  mixins: [mixinPlayer],
  props: {
    value: Object,
  },
  computed: {
    card () { return this.innerValue.card[this.$route.params.index] },
    info () { return _.find(this.card, {'@method':'info'}).args },
    init () { return _.find(this.card, {'@method':'init'}).args },
    prepare () { return _.find(this.card, {'@method':'prepare'}) },
    mix () { return _.find(this.card, {'@method':'mix'}) },
    initBattle () { return _.find(this.card, {'@method':'init-battle'}) },
    ai () { return _.find(this.card, {'@method':'ai'}) },
    input () { return _.find(this.card, {'@method':'input'}) },
    startAction () { return _.find(this.card, {'@method':'start-action'}) },
    action () { return _.find(this.card, {'@method':'action'}) },
    enableDiceBattle: {
      get () { return _.find(this.card, {'@method':'init-battle'}) },
      set (v) {
        if(v){
          this.info.enableDiceBattle = 1
          this.card.push({
            '@method':'init-battle',
            call:'base-targeting-cmd.init',
            args:{ command:{'@self':'class-path'} },
            hook:[]
          })
          this.card.push({
            '@method':'input',
            call:'base-targeting-cmd.input',
            args:{},
            hook:['character.count-skill-ai']
          })
          this.card.push({
            '@method':'ai',
            call:'base-targeting-cmd.ai',
            args:{ command:{'@self':'class-path'} },
            hook:['ai.change']
          })
          this.card.push({
            '@method':'start-action',
            call:'base-targeting-cmd.start-action',
            args:{ Aria:1000, Armor:2000 },
            hook:[]
          })
          this.card.push({
            '@method':'action',
            code:[],
            args:{},
            hook:['character.base-action']
          })
        }else{
          this.$delete(this.info, 'diceBattle')
          _.remove(this.card, {'@method':'init-battle'})
          _.remove(this.card, {'@method':'input'})
          _.remove(this.card, {'@method':'ai'})
          _.remove(this.card, {'@method':'start-action'})
          _.remove(this.card, {'@method':'action'})
        }
      }
    },
    prepareCommand () {
      return {
        code:[
          'status',
          'show'
        ],
        hook:[
          'card/common.declare',
          'card/common.cost',
        ]
      }
    },
    mixCommand () {
      return {
        code:[],
        hook:[],
      }
    },
    initBattleCommand () {
      return {
        hook:[
          'passive.standby'
        ]
      }
    },
    aiCommand () {
      return {
        hook:[
          'ai.change',
          'ai.targeting',
          'ai.exists',
          'ai.turnCount',
          'ai.0-time',
          'ai.cost',
          'targeting.load-live-enemy',
          'targeting.load-live-friend',
          'targeting.load-me',
          'targeting.serious',
          'targeting.without-me',
          'targeting.equip-buff',
          'targeting.unequip-buff',
          'targeting.focus-me'
        ]
      }
    },
    inputCommand () {
      return {
        hook:[
          'targeting.load-live-enemy',
          'targeting.load-live-friend',
          'targeting.load-me',
          'targeting.serious',
          'targeting.without-me',
          'targeting.equip-buff',
          'targeting.unequip-buff',
          'targeting.focus-me',
          'character.count-skill-ai'
        ]
      }
    },
    startActionCommand () {
      return {
        hook:[
          'passive.guard',
          'passive.avoid'
        ]
      }
    },
    actionCommand () {
      return {
        code:[
          'free/attack',
          'free/buff',
          'free/heal'
        ],
        hook:[
          'character.base-action',
          'dice.throw',
          'free/show.skill-performance'
        ],
      }
    },
  },
  data () {
    return {
      innerValue: this.value
    }
  },
  methods: {
    preview (data) {
      this.$store.dispatch('getCodePreview', { 
          code: data,
          complement: 1
        })
        .then((response) => {
          this.$store.dispatch('setCode', response.code)

          // eslint-disable-next-line
          phina.global.app.pushScene(RequestScene({
            assets: response.assets,
            success: (_response, args)=>{
              this.$emit('changePlayer', 'l-player')
              args.$extend(response)
                .$extend({ store:this.$store, bg:'img/ui/bg.png' });
              return 'StoryScene'
            }
          }))
        })
    },
    remove () {
      this.innerValue.card.splice(this.$route.params.index, 1)
      this.$router.push('/card')
    },
    buildCardText () {
      this.info.memo += CardTextBuilder.build(this.card, this.value.card)
    }
  },
  mounted () {
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    }
  }
}
</script>

<style lang="scss" scoped>
.prepare {
  width: 100%;
  height: 400px;
}
.event-ctrl-bar {
  display: flex;

  .digest {
    margin-left: 10px;
  }
}
.ctrl-bar {
  padding: 10px;

  display: flex;
  justify-content: space-between;
}
</style>
